import {
  ImageContainer,
  SelectionCard,
  TextContainer,
  Heading,
  SubHeading
} from "./parent-student.styles";
import Image from "next/legacy/image";
import { IParentOrStudentSelectionData } from "./parent-student.types";
import parentImg from "public/assets/role-parents.svg";
import studentImg from "public/assets/role-students.svg";

const ParentStudentSelection: React.FC<IParentOrStudentSelectionData> = ({
  userType,
  heading,
  subHeading,
  isSelected,
  onClick
}) => {
  return (
    <SelectionCard
      onClick={onClick}
      isSelected={isSelected}
      data-testid={`${userType}-profile-role-select`}
    >
      <ImageContainer>
        <Image
          layout="fill"
          src={userType === "parent" ? parentImg : studentImg}
          alt={heading}
        />
      </ImageContainer>
      <TextContainer>
        <Heading>{heading}</Heading>
        <SubHeading>{subHeading}</SubHeading>
      </TextContainer>
    </SelectionCard>
  );
};

export { ParentStudentSelection };
